module.exports = __webpack_public_path__ + "static/img/download-app-2.084e234.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download-app-2.jpeg
// module id = GnLy
// module chunks = 1